import React from "react"

export default function StrengthTestHome() {
  return <>StrengthTestHome</>
}
